<script>
	import { onMount, onDestroy } from "svelte";
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import FilterForm from "../../../../../components/FilterForm/FilterForm.svelte";
	import PageHeader from "../../../../../components/PageHeader/PageHeader.svelte";
	import SizeSelect from "../../../../../components/SizeSelect/SizeSelect.svelte";
	import client from "../../../../../services/client";
	import MainIssueTable from "./MainIssueTable.svelte";
	import queryString from "query-string";
	import ErrorMessageHandler from "../../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import SveltyPicker from "svelty-picker";
	import { extractErrorMessage } from "../../../../../utils/misc";
	import {
		errorMessage,
		sizeSelect,
		totalPages,
		loading,
		initPage,
	} from "../../../../../store/store";
	import {
		VehicleReportSectionOptions,
		cmmDamageTypeOptions,
		VehicleCarSectionOptions,
	} from "../../../../../utils/options";

	let data = [];
	let startDate;
	let endDate;
	let issueStatus;

	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});
	$: queryParams = `?Page=1&Size=${$sizeSelect}`;
	let searchParams = window.location.search.toString();
	let queryPage = searchParams.includes("page");
	let queryPlateNumber = searchParams.includes("vehicleNumber");
	let queryCarSection = searchParams.includes("carSection");
	let queryReportSection = searchParams.includes("reportSection");
	let queryDamageType = searchParams.includes("damageType");

	$: if (queryPage) {
		queryParams = `?Page=${params.page}&Size=${$sizeSelect}`;
	}
	$: if (queryPlateNumber) {
		queryParams = queryParams.concat(
			`&PlateNumber=${params.vehicleNumber}`
		);
	}

	$: if (queryCarSection) {
		queryParams = queryParams.concat(
			`&CarSection=${String(
				VehicleCarSectionOptions.findIndex(
					(x) => x.label === params.carSection
				)
			)}`
		);
	}

	$: if (queryReportSection) {
		queryParams = queryParams.concat(
			`&ReportSection=${String(
				VehicleReportSectionOptions.findIndex(
					(x) => x.label === params.reportSection
				)
			)}`
		);
	}

	$: if (queryDamageType) {
		queryParams = queryParams.concat(
			`&DamageType=${String(
				cmmDamageTypeOptions.findIndex(
					(x) => x.label === params.damageType
				)
			)}`
		);
	}

	onMount(async () => {
		document.body.scrollIntoView();
		try {
			loading.set(true);
			const res = await client(`/v0/cmm/approved-issue${queryParams}`, {
				method: "GET",
				version: "Tasking",
			});

			data = res.data.data;

			totalPages.set(res.data.totalPage);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err);

			console.log(err.response);
			extractErrorMessage(err);
		}
	});
	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	const trigerSelectIssue = async (limit) => {
		try {
			loading.set(true);
			const res = await client(`/v0/cmm/approved-issue${queryParams}`, {
				method: "GET",
				version: "Tasking",
			});
			data = res.data.data;

			totalPages.set(res.data.totalPage);

			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err);

			console.log(err.response);
			extractErrorMessage(err);
		}
	};

	let load = false;
	export const handleExportCSV = async (status) => {
		try {
			load = true;
			const res = await client("/v0/Issue/v2/ExportApprovedIssues", {
				method: "POST",
				version: "Tasking",
				header: "csv",
				data: {
					startDateRange: startDate ? new Date(startDate) : null,
					endDateRange: endDate ? new Date(endDate) : null,
					statuses: [+issueStatus],
				},
			});

			const url = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "ApprovedIssues.csv"); //or any other extension
			document.body.appendChild(link);
			link.click();

			load = false;
		} catch (err) {
			load = false;
			console.log(err);
		}
	};

	onDestroy(() => {
		initPage.set(1);
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Approved Issues" />
			</Col>
			<div class="d-flex flex-row">
				<Col xs={6}>
					<FilterForm
						carSection
						reportSection
						damageType
						vehicleNumber
						reportStatus
					/>
				</Col>
				<Col class="d-flex justify-content-end mt-2" xs={4}>
					<div class="mx-2">
						<SveltyPicker
							inputClasses="form-control getgo input {startDate &&
							endDate &&
							new Date(startDate) > new Date(endDate)
								? 'border border-danger'
								: ''}"
							bind:value={startDate}
							style="border-radius: 15px;"
							format="yyyy-mm-dd hh:ii"
							placeholder="Start date"
						/>
					</div>
					{#if startDate && endDate && new Date(startDate) > new Date(endDate)}
						<div>
							<p class="error-text">
								Start date cannot be later then end date
							</p>
						</div>
					{/if}
					<div class="mt-2">to</div>
					<div class="mx-2">
						<SveltyPicker
							inputClasses="form-control getgo input {startDate &&
							endDate &&
							new Date(startDate) > new Date(endDate)
								? 'border border-danger'
								: ''}"
							bind:value={endDate}
							format="yyyy-mm-dd hh:ii"
							placeholder="End date"
						/>
					</div>
					{#if startDate && endDate && new Date(startDate) > new Date(endDate)}
						<div>
							<p class="error-text">
								End date cannot be sooner then end date
							</p>
						</div>
					{/if}
					<div class="mx-2">
						<label for="issue-status-filter" class="visually-hidden"
							>Filter by issue status</label
						>
						<select
							id="issue-status-filter"
							class="form-select getgo select"
							type="text"
							bind:value={issueStatus}
						>
							<option value=""> All Status</option>
							<option value="0"> Pending</option>
							<option value="1"> Attached</option>
							<option value="2"> Resolved</option>
						</select>
					</div>
				</Col>
				<div class="mx-2 mt-2">
					{#if !load}
						<div class="mx-2 my-1">
							<Button
								on:click={() => handleExportCSV(0)}
								class="themeButton primary px-4"
								>Export CSV</Button
							>
						</div>
					{:else if load}
						<div class="">
							<Button
								class="themeButton primary px-4"
								type="button"
								disabled
							>
								<output
									class="spinner-grow spinner-grow-sm"
									aria-hidden="true"
								/>
								Loading...
							</Button>
						</div>
					{/if}
					<div class="d-flex align-items-center mt-5">
						<SizeSelect trigerSelect={trigerSelectIssue} />
					</div>
				</div>
			</div>
			<div />
		</div>
	</Col>
	<Col class="my-2">
		<MainIssueTable {data} />
	</Col>
</Row>
